import PropTypes from 'prop-types';
import React from 'react';

import ActionButton from '@/components/ActionButton';
import AsyncButton from '@/components/AsyncButton';
import ArchiveIcon from '@/components/Icon/Archive';
import CanView from '@/containers/CanView';

const ArchiveButton = ({ permission, ...rest }) => (
  <CanView permission={permission}>
    <ActionButton
      text="Архивировать"
      button={AsyncButton}
      icon={ArchiveIcon}
      {...rest}
    />
  </CanView>
);

ArchiveButton.propTypes = {
  permission: PropTypes.func.isRequired,
};

export default ArchiveButton;
